
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { AiCriteria, AiWrapper, AiScenario, AiResponse } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';

/**
 * appels
 * @author LMA
 */
export class AiCmd extends WizCommand<AiWrapper> {
 
  protected model: Model = null;

  // les données à faire passer pour traitement retour
  public carrier: any = null;

  public host: string = "https://api.openai.com/v1/chat/completions";
  public iamodel: string = "gpt-4o";

  public api: ExternalAPI;

  public viewCallback: Function = null;

  // object d'origine pour alimentation
  public ref: any; 
  
  // information sur le fichier d'origine pour appel de vecteur
  public bytes: string;
  public kind: string;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  /**
   * construction du wrapper
   * @returns 
   */
  private buildWrapper(): AiWrapper {
    let wrapper: AiWrapper = new AiWrapper();
    let scen: AiScenario = new AiScenario();
    // scen.apiKey = this.apiKey;
    scen.host = this.host;
    scen.model = this.iamodel;

    let crit: AiCriteria = new AiCriteria();
    crit.domain = this.model.domainCode;
    crit.businessUnitCode = this.model.businessUnitCode;
    crit.visionCode = this.model.visionCode;

    wrapper.scenario = scen;
    wrapper.criteria = crit;


    return wrapper;
  }


  /**
   * question IA
   * @return la réponse IA
   */
  public question(questionCode: string, prompt: string, viewCallback: Function = null, maxToken: number = 150, summarize: boolean = false): AiCmd {
    
    this.viewCallback = viewCallback;

    const wrapper: AiWrapper = this.buildWrapper();
    wrapper.criteria.prompt = prompt;
    wrapper.criteria.max_tokens = maxToken;
    wrapper.criteria.summarize = summarize;
    wrapper.criteria.questionCode = questionCode;
    this.api = ExternalAPI.IA_TEXT_API;
    this.configureRemote(ExternalAPI.IA_TEXT_API, wrapper);
    return this;
  }

  /**
   * la demande d'image
   * @return l'url de la réponse
   */
  public drawImage(questionCode: string, prompt: string, viewCallback: Function = null): AiCmd {
    
    this.viewCallback = viewCallback;

    const wrapper: AiWrapper = this.buildWrapper();
    wrapper.criteria.prompt = prompt;
    wrapper.criteria.questionCode = questionCode;
    wrapper.scenario.host = "https://api.openai.com/v1/images/generations";
    wrapper.scenario.size = "1024x1024";

    this.api = ExternalAPI.IA_IMAGE_API;
    this.configureRemote(ExternalAPI.IA_IMAGE_API, wrapper);
    return this;
  }

  /**
   * extraction en masse des vecteurs
   * @return les mots clés
   */
  public massExtractVector(questionCode: string, bytes: string, kind: string, ref: any): AiCmd {
    this.bytes = bytes;
    this.kind = kind;
    this.ref = ref;
    return this.extractVector(questionCode, bytes, kind)
  }

  /**
   * extraction d'un CV
   * @return les mots clés
   */
  public massExtractCV(questionCode: string, question: string, bytes: string, kind: string, ref: any): AiCmd {
    this.bytes = bytes;
    this.kind = kind;
    this.ref = ref;
    return this.extractCVWithQuestion(questionCode, question, bytes, kind)
  }

  /**
   * extraction d'un CV
   * @return les mots clés
   */
  public extractCV(questionCode: string, bytes: string, kind: string, viewCallback: Function = null): AiCmd {
    
    this.viewCallback = viewCallback;

    const wrapper: AiWrapper = this.buildWrapper();
    wrapper.criteria.bytes = bytes;
    wrapper.criteria.fileKind = kind;
    wrapper.criteria.questionCode = questionCode;
    wrapper.scenario.persist = true;
    wrapper.scenario.persistPrompt = false;
    // persist prompt
    this.api = ExternalAPI.IA_CV_API;
    this.configureRemote(ExternalAPI.IA_CV_API, wrapper);
    return this;
  }

  /**
   * extraction d'un CV
   * @param questionCode le type de question pour normalisation des réponses (questionCode sur response)
   * @return les mots clés
   */
  public extractCVWithQuestion(questionCode: string, question: string, bytes: string, kind: string, viewCallback: Function = null): AiCmd {
    let cmd: AiCmd = this.extractCV(questionCode, bytes, kind, viewCallback);
    if(!!question)
    (cmd.context as AiWrapper).criteria.prompt = question;
    return cmd;
  }

  /**
   * extraction d'un CV
   * @return les mots clés
   */
  public extractVector(questionCode: string, bytes: string, kind: string, viewCallback: Function = null): AiCmd {
    
    this.viewCallback = viewCallback;

    const wrapper: AiWrapper = this.buildWrapper();
    wrapper.criteria.bytes = bytes;
    wrapper.criteria.fileKind = kind;
    wrapper.criteria.questionCode = questionCode;
    wrapper.scenario.host = "https://api.openai.com/v1/embeddings";
    wrapper.scenario.model = "text-embedding-3-small";
    wrapper.scenario.persist = true;
    wrapper.scenario.persistPrompt = false;
    // persist prompt
    this.api = ExternalAPI.IA_VECTOR_API;
    this.configureRemote(ExternalAPI.IA_VECTOR_API, wrapper);
    return this;
  }

  /**
   * description d'une image
   * questionCode le prompt
   * @return la description
   */
  public imageToText(prompt: string, bytes: any, viewCallback: Function = null): AiCmd {
    
    this.viewCallback = viewCallback;

    const wrapper: AiWrapper = this.buildWrapper();
    wrapper.criteria.bytes = bytes;
    wrapper.criteria.prompt = prompt;
    wrapper.scenario.host = "https://api.openai.com/v1/chat/completions";
    wrapper.scenario.model = "gpt-4o";
    wrapper.scenario.persist = true;
    wrapper.scenario.persistPrompt = false;
    // persist prompt
    this.api = ExternalAPI.IA_IMAGETOTEXT_API;
    this.configureRemote(ExternalAPI.IA_IMAGETOTEXT_API, wrapper);
    return this;
  }


  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();

    let result: AiResponse = this.result?.entity || null;

    if(this.viewCallback) {
      this.viewCallback(result, this.carrier);
    }

  }
}
